import { ReactNode } from 'react';
import Ai from '@/assets/icons/docs/ai.svg';
import Apk from '@/assets/icons/docs/apk.svg';
import Doc from '@/assets/icons/docs/doc.svg';
import Fig from '@/assets/icons/docs/fig.svg';
import Gif from '@/assets/icons/docs/gif.svg';
import Jpg from '@/assets/icons/docs/jpg.svg';
import Mp3 from '@/assets/icons/docs/mp3.svg';
import Mp4 from '@/assets/icons/docs/mp4.svg';
import Otf from '@/assets/icons/docs/otf.svg';
import Pdf from '@/assets/icons/docs/pdf.svg';
import Pkg from '@/assets/icons/docs/pkg.svg';
import Png from '@/assets/icons/docs/png.svg';
import Ppt from '@/assets/icons/docs/ppt.svg';
import Psd from '@/assets/icons/docs/psd.svg';
import Rar from '@/assets/icons/docs/rar.svg';
import Svg from '@/assets/icons/docs/svg.svg';
import Ttf from '@/assets/icons/docs/ttf.svg';
import Wav from '@/assets/icons/docs/wav.svg';
import Xls from '@/assets/icons/docs/xls.svg';
import Zip from '@/assets/icons/docs/zip.svg';

const fileTypesMap: Record<string, ReactNode> = {
  ai: <Ai />,
  apk: <Apk />,
  doc: <Doc />,
  fig: <Fig />,
  gif: <Gif />,
  jpg: <Jpg />,
  mp3: <Mp3 />,
  mp4: <Mp4 />,
  otf: <Otf />,
  pdf: <Pdf />,
  pkg: <Pkg />,
  png: <Png />,
  ppt: <Ppt />,
  psd: <Psd />,
  rar: <Rar />,
  svg: <Svg />,
  ttf: <Ttf />,
  wav: <Wav />,
  xls: <Xls />,
  zip: <Zip />,
};

export const getFileTypeIcon = (type?: string): ReactNode => {
  if (!type) return fileTypesMap.doc;

  if (type in fileTypesMap) {
    return fileTypesMap[type];
  }

  return fileTypesMap.doc;
};